import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const PolicyNumber = (props) => {
  return (
    <FormGroup controlId="policyNumber">
      <Col componentClass={ControlLabel} sm={5}>
        Policy Number
      </Col>
    <Col sm={7}>
        <FormControl
          type="text"
          value={props.policyNumber}
          onChange={props.handleChangePolicyNumber}
          autoComplete="off"
          required={props.isPolicyNumberRequired}
          />
    </Col>
    </FormGroup>
  )
}

PolicyNumber.propTypes = {
  policyNumber: PropTypes.string,
  handleChangePolicyNumber: PropTypes.func,
  isPolicyNumberRequired: PropTypes.bool
};

export default PolicyNumber;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/policyNumber/PolicyNumber.js